// extracted by css-extract-rspack-plugin
export default {"container":"rv7LhBwBtaMbsTNX"};